import { Reveal } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "L'intervento è doloroso?",
    a: "L'intervento si esegue in anestesia locale e, su richiesta, con sedazione cosciente assistita da anestesista. La maggior parte dei pazienti riferisce solo un lieve fastidio nei giorni successivi, gestibile con comuni antidolorifici.",
  },
  {
    q: "Quanto tempo serve per avere i denti fissi?",
    a: "Con il carico immediato la protesi provvisoria fissa viene avvitata in circa 6 ore, se le condizioni cliniche lo consentono: avrai il provvisorio fisso in giornata. La protesi definitiva viene consegnata dopo 3–6 mesi, a guarigione completata.",
  },
  {
    q: "Quali materiali vengono utilizzati?",
    a: "Impianti in titanio biocompatibile di produttori certificati CE, con documentazione e passaporto implantare consegnato al paziente. Le protesi definitive sono realizzate in composito medicale certificato con garanzia economica 10 anni, con possibilità di effettuare il definitivo in ceramica nano ibrida.",
  },
  {
    q: "Il prezzo di €4.900 è davvero tutto incluso?",
    a: "Sì: comprende visita, TAC o panoramica, estrazioni necessarie, impianti, protesi provvisoria e definitiva, controlli post-operatori e garanzia economica 10 anni su tutto il lavoro compresi gli impianti (per 10 anni non spenderai più nulla). È un prezzo indicativo per arcata, confermato con preventivo scritto dopo la valutazione clinica.",
  },
  {
    q: "Sono disponibili finanziamenti?",
    a: "Sì. Finanziamento con Compass o Cofidis (salvo approvazione della finanziaria). Finanziamento in 10 mesi senza interessi fino a €2.000 (salvo approvazione della finanziaria). Pagamento a rate: in caso di rifiuto da parte della finanziaria, fino a €3.000 direttamente con lo studio e senza interessi o spese (a insindacabile giudizio e approvazione da parte dello studio convenzionato).",
  },
  {
    q: "E se non ho abbastanza osso?",
    a: "La TAC 3D permette di valutare con precisione la quantità di osso disponibile. In molti casi si può intervenire con impianti inclinati o tecniche specifiche evitando innesti. Il direttore sanitario valuterà la soluzione più adatta al tuo caso.",
  },
  {
    q: "Come funziona la garanzia economica di 10 anni?",
    a: "La garanzia economica 10 anni copre tutto il lavoro svolto compresi gli impianti: per 10 anni non spenderai più nulla. Vale a condizione di seguire i controlli periodici e le sedute di igiene programmate presso lo studio. Le condizioni complete vengono consegnate per iscritto insieme al piano di cura.",
  },
];

export const Faq = () => (
  <section id="faq" className="py-24 md:py-32 px-6 md:px-12" data-testid="faq-section">
    <div className="max-w-4xl mx-auto">
      <Reveal>
        <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#7D9285] mb-4">Domande frequenti</p>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#15201A]">
          I dubbi più <em className="italic text-[#385244]">comuni</em> sugli impianti dentali
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-14">
          {faqs.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-[#D8DDD9]">
              <AccordionTrigger
                className="text-left text-lg md:text-xl font-semibold text-[#15201A] hover:text-[#385244] hover:no-underline py-6"
                data-testid={`faq-trigger-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base md:text-lg leading-relaxed text-[#5C6B61] pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
